import axiosInstance from './axiosInstance';

export const placeOrderApi       = (data)    => axiosInstance.post('/orders', data);export const getMyOrdersApi      = (params)  => axiosInstance.get('/orders', { params });
export const getOrderByIdApi     = (id)      => axiosInstance.get(`/orders/${id}`);
export const cancelOrderApi      = (id, reason) => axiosInstance.patch(`/orders/${id}/cancel`, { reason });
export const getMyOrderStatsApi  = ()        => axiosInstance.get('/orders/my-stats');

// Admin
export const getAllOrdersApi      = (params) => axiosInstance.get('/orders/admin/all', { params });
export const updateOrderStatusApi = (id, data) => axiosInstance.patch(`/orders/admin/${id}/status`, data);
